declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

const FB_PIXEL_ID = '893245413379842'

export function initFBPixel() {
  if (window.fbq) return

  const n = (window.fbq = function (...args: unknown[]) {
    if ((n as any).callMethod) {
      ;(n as any).callMethod.apply(n, args)
    } else {
      ;(n as any).queue.push(args)
    }
  }) as any

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = [] as unknown[]

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  // noscript fallback pixel
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${FB_PIXEL_ID}&ev=PageView&noscript=1`
  document.body.appendChild(img)

  window.fbq('init', FB_PIXEL_ID)
  window.fbq('track', 'PageView')
}

export function trackViewContent() {
  if (window.fbq) {
    window.fbq('track', 'ViewContent')
  }
}

export function trackAddToCart(productName?: string, value?: number) {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: productName || 'ElixirX Product',
      content_type: 'product',
      value: value || 0,
      currency: 'USD',
    })
  }
}
